import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-restore-page",
  "use": "svg_i-restore-page-usage",
  "viewBox": "0 0 11 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 18\" id=\"svg_i-restore-page\"><g fill=\"currentColor\" fill-rule=\"nonzero\"><path d=\"M0 7h2v10h7V7h2v1h-1v10H1V8H0z\" /><path d=\"M5 2.75 2.507 5.243 1.8 4.536 5.52.81l3.723 3.726-.707.707L6 2.707V10H5z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol